import { useEffect } from "react"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate, useParams } from "react-router-dom"

import styles from "./style.module.scss"
import { UserInList } from "./UserInList"

import { Chat } from "modules/Chat/utils/interfaces"
import { setActiveChatId } from "utils/store/slices"
import { AppDispatch } from "utils/store/store"
import { chatSelector } from "utils/store/selectors/chat"

interface Props {
    chats: Chat[]
}

export function UsersList({ chats }: Props) {
    const dispatch = useDispatch<AppDispatch>()
    const { chatId } = useParams<{ chatId?: string }>()
    const navigate = useNavigate()
    const { activeChatId } = useSelector(chatSelector)

    useEffect(() => {
        if (chatId) {
            dispatch(setActiveChatId(+chatId))
        }
    }, [chatId])

    const handleChatClick = (chatId: number) => {
        dispatch(setActiveChatId(chatId))
        navigate(`/chat/${chatId}`, { replace: true })
    }

    return (
        <div className={styles.container}>
            {chats.map((chat) => (
                <UserInList
                    data={chat}
                    isActive={chat.chatId === activeChatId}
                    key={chat.chatId}
                    onClick={handleChatClick}
                />
            ))}
        </div>
    )
}
